(function(){
  'use strict';

  var CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 4h2l2.2 12.4a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21.5 8H6.2"/><circle cx="10" cy="21" r="1.4"/><circle cx="17" cy="21" r="1.4"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var CHECK_ICON_WRAP = '<div class="japow-bys-success__icon">' + CHECK_SVG + '</div>';

  var ICON_FALLBACK = {
    top: '<svg viewBox="0 0 48 48" fill="none" stroke="white" stroke-width="1.5"><path d="M17 6 L10 10 L6 18 L11 21 L14 17 L14 42 L34 42 L34 17 L37 21 L42 18 L38 10 L31 6 C31 6 28 9 24 9 C20 9 17 6 17 6Z" stroke-linejoin="round"/></svg>',
    bottom: '<svg viewBox="0 0 48 48" fill="none" stroke="white" stroke-width="1.5"><path d="M15 6 H33 L34 22 L37 42 H29 L25 24 L23 24 L19 42 H11 L14 22 Z" stroke-linejoin="round"/></svg>',
    sock: '<svg viewBox="0 0 48 48" fill="none" stroke="white" stroke-width="1.5"><path d="M18 5 H30 V24 L38 34 C40 37 39 41 35 42 H21 C18 42 16 40 16 37 V24 Z" stroke-linejoin="round"/><path d="M16 30 H30" /></svg>',
    headwear: '<svg viewBox="0 0 48 48" fill="none" stroke="white" stroke-width="1.5"><path d="M9 30 C9 16 16 8 24 8 C32 8 39 16 39 30" stroke-linecap="round"/><path d="M7 30 H41 V33 C41 36 38 38 35 38 H13 C10 38 7 36 7 33 Z" stroke-linejoin="round"/><path d="M18 30 V22 M24 30 V20 M30 30 V22" stroke-linecap="round"/></svg>'
  };

  var GENDER_LABEL = { mens: "Men's", womens: "Women's" };
  var WEIGHT_LABEL = { light: 'Lightweight', mid: 'Midweight', heavy: 'Heavyweight' };

  // The colour a size should default to when a product has more than one
  // colourway — checked case-insensitively against each colour's label.
  var PREFERRED_COLOR = 'black';

  var initialized = {};

  function money(n){ return '$' + Number(n || 0).toFixed(2); }
  function round2(n){ return Math.round(n * 100) / 100; }
  function escapeHtml(s){
    return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  // Turns each slot's flat `variants` list (as emitted by the Liquid snippet,
  // one entry per Shopify variant with a `primary` value — e.g. Size — and an
  // optional `secondary` value — e.g. Colour) into a `variantMap` keyed by the
  // primary value. When a product has a real secondary (colour) dimension,
  // each entry also carries `alts`: every colourway available at that size,
  // so an out-of-stock size can offer a same-product colour swap first.
  function buildDerivedData(data){
    var slots = (data && data.slots) || {};
    Object.keys(slots).forEach(function(key){
      var slot = slots[key];
      if (!slot || key === '_' || !slot.variants) return;
      var hasSecondary = !!(slot.secondaryValues && slot.secondaryValues.length);
      var vm = {};
      slot.variants.forEach(function(v){
        if (v.primary === '' || v.primary == null) return;
        if (!vm[v.primary]) vm[v.primary] = hasSecondary ? { id: null, available: false, alts: {} } : { id: null, available: false };
        if (hasSecondary){
          if (v.secondary !== '' && v.secondary != null){
            vm[v.primary].alts[v.secondary] = { id: v.id, available: v.available, image: v.image || '' };
          }
        } else if (!vm[v.primary].id){
          vm[v.primary].id = v.id;
          vm[v.primary].available = v.available;
          vm[v.primary].image = v.image || '';
        }
      });
      if (hasSecondary){
        Object.keys(vm).forEach(function(primaryVal){
          var entry = vm[primaryVal];
          var chosenColor = null, chosen = null;

          // 1. Prefer the site-wide preferred colour (black) for this size,
          //    but only if it's actually in stock — an out-of-stock black
          //    should not "win" over a colour that's available.
          Object.keys(entry.alts).some(function(c){
            if (String(c).trim().toLowerCase() === PREFERRED_COLOR && entry.alts[c].available){
              chosenColor = c; chosen = entry.alts[c];
              return true;
            }
            return false;
          });

          // 2. Otherwise, the first colour (in the product's listed order)
          //    that's in stock at this size.
          if (!chosen){
            for (var i = 0; i < slot.secondaryValues.length; i++){
              var c2 = slot.secondaryValues[i];
              if (entry.alts[c2] && entry.alts[c2].available){ chosenColor = c2; chosen = entry.alts[c2]; break; }
            }
          }

          // 3. Nothing in stock in any colour — fall back to whichever
          //    colour is listed first, even though it's sold out, purely so
          //    there's something to display. This intentionally leaves
          //    entry.available === false, which is what surfaces the
          //    "(check below)" note on the size tile and opens the swap
          //    panel with the other sizes/products to try instead.
          if (!chosen){
            for (var j = 0; j < slot.secondaryValues.length; j++){
              var c3 = slot.secondaryValues[j];
              if (entry.alts[c3]){ chosenColor = c3; chosen = entry.alts[c3]; break; }
            }
          }
          if (!chosen){
            var anyKey = Object.keys(entry.alts)[0];
            if (anyKey){ chosenColor = anyKey; chosen = entry.alts[anyKey]; }
          }

          entry.id = chosen ? chosen.id : null;
          entry.available = chosen ? chosen.available : false;
          entry.defaultColor = chosenColor;
          entry.image = chosen ? (chosen.image || '') : '';
        });
      }
      slot.variantMap = vm;
    });
  }

  function initWizard(root){
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId || initialized[sectionId]) return;
    initialized[sectionId] = true;

    var dataEl = root.querySelector('[data-bys-data]');
    var data = { bundleDiscountPercent: 10, slots: {} };
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('Build Your System: could not parse product data', e); }
    buildDerivedData(data);

    var historyEl = root.querySelector('[data-bys-history]');
    var stageEl = root.querySelector('[data-bys-stage]');

    var state = {
      gender: null, weight: null, blSize: null,
      topOverride: null, bottomOverride: null,
      topColorOverride: null, bottomColorOverride: null,
      currentKitCategory: null, kitOptionIndex: null, kitVariant: null,
      kitDone: { sock: false, headwear: false }
    };
    var currentStage = 'gender';
    var cartBusy = false;
    var lastError = '';

    function getSlot(key){ return data.slots[key] || null; }
    function getSystemSlot(gender, weight, part){ return getSlot(gender + '_' + weight + '_' + part); }
    function getKitSlot(kind, i){ return getSlot(kind + '_' + i); }
    function kitSlots(kind){
      var out = [];
      for (var i = 0; i < 8; i++){
        var s = getKitSlot(kind, i);
        if (s) out.push({ index: i, data: s });
      }
      return out;
    }
    function isWeightComplete(gender, weight){
      return !!(getSystemSlot(gender, weight, 'top') && getSystemSlot(gender, weight, 'bottom'));
    }
    function isGenderAvailable(gender){
      return isWeightComplete(gender, 'light') || isWeightComplete(gender, 'mid') || isWeightComplete(gender, 'heavy');
    }

    function currentTopBottom(){
      var topKey = state.topOverride || (state.gender + '_' + state.weight + '_top');
      var bottomKey = state.bottomOverride || (state.gender + '_' + state.weight + '_bottom');
      return { topKey: topKey, bottomKey: bottomKey, top: getSlot(topKey), bottom: getSlot(bottomKey) };
    }

    // The variant a size resolves to for this slot — the colour override's
    // variant if one is set and actually exists at this size, else the
    // slot's default (preferred-colour, in-stock) variant for that size.
    function effectiveVariant(slot, sizeValue, colorOverride){
      if (!slot) return null;
      var hasOptions = slot.optionValues && slot.optionValues.length > 0;
      if (!hasOptions) return firstVariant(slot);
      var entry = slot.variantMap[sizeValue];
      if (!entry) return null;
      if (colorOverride && entry.alts && entry.alts[colorOverride]) return entry.alts[colorOverride];
      return entry;
    }

    // Priority 1: the SAME product, a different colourway, same size.
    function altColorAlternatives(slot, sizeValue){
      var entry = slot && slot.variantMap && slot.variantMap[sizeValue];
      if (!entry || !entry.alts) return [];
      var out = [];
      Object.keys(entry.alts).forEach(function(c){
        var v = entry.alts[c];
        if (v && v.available) out.push({ type: 'color', color: c, id: v.id, image: v.image || '' });
      });
      return out;
    }

    // Priority 2: a different base-layer product for the SAME gender and
    // garment (any weight) that has this size in stock. Never crosses gender.
    function altProductAlternatives(part, excludeKey, sizeValue){
      var suffix = '_' + part;
      var genderPrefix = state.gender + '_';
      var out = [];
      Object.keys(data.slots).forEach(function(key){
        if (key === excludeKey) return;
        if (key.length <= suffix.length || key.slice(-suffix.length) !== suffix) return;
        if (key.slice(0, genderPrefix.length) !== genderPrefix) return;
        var slot = data.slots[key];
        if (!slot || !slot.variantMap) return;
        var entry = slot.variantMap[sizeValue];
        if (entry && entry.available) out.push({ key: key, data: slot });
      });
      return out;
    }

    // Accepts either a slot/product object (uses its default photo) or a
    // plain image URL string directly — the latter lets a recap card show a
    // specific VARIANT's photo (e.g. the colourway that's actually in the
    // cart) instead of always falling back to the product's default photo.
    function iconMarkup(slotOrUrl, fallbackSvg){
      var url = typeof slotOrUrl === 'string' ? slotOrUrl : (slotOrUrl && slotOrUrl.image);
      return url ? '<img src="' + url + '" alt="">' : fallbackSvg;
    }

    function optionTiles(action, slot, selectedValue){
      var values = (slot && slot.optionValues) || [];
      return values.map(function(v){
        var entry = slot.variantMap[v];
        var known = !!entry;
        var available = known && entry.available;
        var cls = 'japow-bys-size-tile' + (selectedValue === v ? ' is-selected' : '') + (known && !available ? ' is-unavailable' : '');
        return '<button type="button" class="' + cls + '" data-action="' + action + '" data-value="' + escapeHtml(v) + '"' + (known && !available ? ' disabled' : '') + '>' +
          escapeHtml(v) + (known && !available ? ' <span style="opacity:.7">(sold out)</span>' : '') +
        '</button>';
      }).join('');
    }

    function recapCardHtml(kicker, slot, fallbackSvg, extraHtml, imageUrlOverride){
      if (!slot){
        return '<div class="japow-bys-product-card japow-bys-product-card--empty">Product not set up yet — add one to this slot in the theme editor.</div>';
      }
      return '<div class="japow-bys-product-card">' +
        '<div class="japow-bys-product-card__icon">' + iconMarkup(imageUrlOverride || slot.image, fallbackSvg) + '</div>' +
        '<div class="japow-bys-product-card__body">' +
          '<div class="japow-bys-product-card__kicker">' + kicker + '</div>' +
          '<div class="japow-bys-product-card__name">' + escapeHtml(slot.title) + '</div>' +
          '<div class="japow-bys-product-card__price">' + money(slot.price) + '</div>' +
          (extraHtml || '') +
        '</div>' +
      '</div>';
    }

    function kitOptionTileHtml(kind, index, slot, fallbackSvg){
      return '<div class="japow-bys-add-tile">' +
        '<button type="button" class="japow-bys-add-tile__select" data-action="kit-option" data-value="' + index + '">' +
          '<div class="japow-bys-add-tile__icon">' + iconMarkup(slot, fallbackSvg) + '</div>' +
          '<div class="japow-bys-add-tile__name">' + escapeHtml(slot.title) + '</div>' +
          '<div class="japow-bys-add-tile__foot"><span class="japow-bys-add-tile__price">' + money(slot.price) + '</span><span class="japow-bys-add-tile__action">Select</span></div>' +
        '</button>' +
      '</div>';
    }

    function swapTileHtml(part, slotKey, slot, fallbackSvg){
      return '<div class="japow-bys-add-tile">' +
        '<button type="button" class="japow-bys-add-tile__select" data-action="bl-swap-part" data-part="' + part + '" data-value="' + escapeHtml(slotKey) + '">' +
          '<div class="japow-bys-add-tile__icon">' + iconMarkup(slot, fallbackSvg) + '</div>' +
          '<div class="japow-bys-add-tile__name">' + escapeHtml(slot.title) + '</div>' +
          '<div class="japow-bys-add-tile__foot"><span class="japow-bys-add-tile__price">' + money(slot.price) + '</span><span class="japow-bys-add-tile__action">Swap in</span></div>' +
        '</button>' +
      '</div>';
    }

    function colorSwapTileHtml(part, color, slot, fallbackSvg, imageUrl){
      return '<div class="japow-bys-add-tile">' +
        '<button type="button" class="japow-bys-add-tile__select" data-action="bl-swap-color" data-part="' + part + '" data-value="' + escapeHtml(color) + '">' +
          '<div class="japow-bys-add-tile__icon">' + iconMarkup(imageUrl || slot.image, fallbackSvg) + '</div>' +
          '<div class="japow-bys-add-tile__name">' + escapeHtml(slot.title) + ' &mdash; ' + escapeHtml(color) + '</div>' +
          '<div class="japow-bys-add-tile__foot"><span class="japow-bys-add-tile__price">' + money(slot.price) + '</span><span class="japow-bys-add-tile__action">Swap in</span></div>' +
        '</button>' +
      '</div>';
    }

    function swapPanelHtml(part, slotKey, slot, sizeValue, fallbackSvg){
      var colorAlts = altColorAlternatives(slot, sizeValue);
      var productAlts = altProductAlternatives(part, slotKey, sizeValue);
      var label = part === 'top' ? 'Top' : 'Bottom';
      var any = colorAlts.length || productAlts.length;
      var html = '<div class="japow-bys-swap-panel"><div class="japow-bys-swap-panel__label"><strong>' + label + ' — size ' + escapeHtml(sizeValue) + '</strong> is out of stock in this pick.' + (any ? ' Try one of these instead:' : '') + '</div>';
      if (any){
        var tiles = colorAlts.map(function(a){ return colorSwapTileHtml(part, a.color, slot, fallbackSvg, a.image); })
          .concat(productAlts.map(function(a){ return swapTileHtml(part, a.key, a.data, fallbackSvg); }))
          .join('');
        html += '<div class="japow-bys-tile-row japow-bys-tile-row--4">' + tiles + '</div>';
      } else {
        html += '<div class="japow-bys-swap-empty">No other option has size ' + escapeHtml(sizeValue) + ' in stock right now — try a different size.</div>';
      }
      html += '</div>';
      return html;
    }

    function blSizeTilesHtml(top, bottom, sizeValues){
      return sizeValues.map(function(v){
        var topEntry = top.variantMap[v];
        var bottomEntry = bottom.variantMap[v];
        var fullyOk = !!(topEntry && topEntry.available && bottomEntry && bottomEntry.available);
        var cls = 'japow-bys-size-tile' + (state.blSize === v ? ' is-selected' : '') + (!fullyOk ? ' is-partial' : '');
        var note = fullyOk ? '' : ' <span style="opacity:.7">(check below)</span>';
        return '<button type="button" class="' + cls + '" data-action="bl-size-pick" data-value="' + escapeHtml(v) + '">' + escapeHtml(v) + note + '</button>';
      }).join('');
    }

    // ==================== STAGE RENDERERS ====================

    function stageGender(){
      var mensAvail = isGenderAvailable('mens');
      var womensAvail = isGenderAvailable('womens');
      return '<div class="japow-bys-stage-label">Step 1 &mdash; Who\'s it for?</div>' +
        '<div class="japow-bys-tile-row japow-bys-tile-row--2">' +
          '<button type="button" class="japow-bys-tile" data-action="bl-gender" data-value="mens"' + (!mensAvail ? ' disabled' : '') + '><span class="japow-bys-tile__label">Men\'s</span><span class="japow-bys-tile__sub">' + (mensAvail ? 'Base layer top &amp; bottom' : 'Coming soon') + '</span></button>' +
          '<button type="button" class="japow-bys-tile" data-action="bl-gender" data-value="womens"' + (!womensAvail ? ' disabled' : '') + '><span class="japow-bys-tile__label">Women\'s</span><span class="japow-bys-tile__sub">' + (womensAvail ? 'Base layer top &amp; bottom' : 'Coming soon') + '</span></button>' +
        '</div>';
    }

    function stageWeight(){
      var weights = [['light', '1', 'Lightweight', 'Mild days, high output'], ['mid', '2', 'Midweight', 'All-mountain, most days'], ['heavy', '3', 'Heavyweight', 'Coldest, deepest days']];
      var tiles = weights.map(function(w){
        var complete = isWeightComplete(state.gender, w[0]);
        return '<button type="button" class="japow-bys-tile" data-action="bl-weight" data-value="' + w[0] + '" data-layers="' + w[1] + '"' + (!complete ? ' disabled' : '') + '>' +
          '<span class="japow-bys-layer-icon"><span></span><span></span><span></span></span>' +
          '<span class="japow-bys-tile__label">' + w[2] + '</span>' +
          '<span class="japow-bys-tile__sub">' + (complete ? w[3] : 'Coming soon') + '</span></button>';
      }).join('');
      return '<div class="japow-bys-stage-label">Step 2 &mdash; How cold do you run?</div>' +
        '<div class="japow-bys-tile-row japow-bys-tile-row--3">' + tiles + '</div>' +
        '<button type="button" class="japow-bys-restart" data-action="restart-bl">Start over</button>';
    }

    function stageBLSize(){
      var ctb = currentTopBottom();
      var topKey = ctb.topKey, bottomKey = ctb.bottomKey, top = ctb.top, bottom = ctb.bottom;
      var ready = !!(top && bottom);
      var total = ready ? (top.price + bottom.price) : 0;

      var sizeValues = [];
      if (ready){
        var seen = {};
        (top.optionValues || []).concat(bottom.optionValues || []).forEach(function(v){ if (!seen[v]){ seen[v] = true; sizeValues.push(v); } });
      }
      var hasOptions = ready && sizeValues.length > 0;
      var sizesHtml = hasOptions ? blSizeTilesHtml(top, bottom, sizeValues) : '';

      var topVariant = (ready && hasOptions && state.blSize) ? effectiveVariant(top, state.blSize, state.topColorOverride) : null;
      var bottomVariant = (ready && hasOptions && state.blSize) ? effectiveVariant(bottom, state.blSize, state.bottomColorOverride) : null;
      var topOk = !hasOptions || !!(topVariant && topVariant.available);
      var bottomOk = !hasOptions || !!(bottomVariant && bottomVariant.available);
      var canAdd = ready && (!hasOptions || !!state.blSize) && topOk && bottomOk;

      var swapHtml = '';
      if (ready && hasOptions && state.blSize){
        if (!topOk) swapHtml += swapPanelHtml('top', topKey, top, state.blSize, ICON_FALLBACK.top);
        if (!bottomOk) swapHtml += swapPanelHtml('bottom', bottomKey, bottom, state.blSize, ICON_FALLBACK.bottom);
      }

      var topKicker = 'Base Layer Top' + (state.topColorOverride ? (' &middot; ' + escapeHtml(state.topColorOverride)) : '');
      var bottomKicker = 'Base Layer Bottom' + (state.bottomColorOverride ? (' &middot; ' + escapeHtml(state.bottomColorOverride)) : '');
      var topUndo = (state.topOverride || state.topColorOverride) ? '<button type="button" class="japow-bys-swap-undo" data-action="bl-swap-reset" data-part="top">Use original top</button>' : '';
      var bottomUndo = (state.bottomOverride || state.bottomColorOverride) ? '<button type="button" class="japow-bys-swap-undo" data-action="bl-swap-reset" data-part="bottom">Use original bottom</button>' : '';

      return '<div class="japow-bys-stage-label">Step 3 &mdash; Your system</div>' +
        '<div class="japow-bys-result">' +
          recapCardHtml(topKicker, top, ICON_FALLBACK.top, topUndo, topVariant && topVariant.image) +
          recapCardHtml(bottomKicker, bottom, ICON_FALLBACK.bottom, bottomUndo, bottomVariant && bottomVariant.image) +
        '</div>' +
        (ready ? (
          (hasOptions ? '<div class="japow-bys-size-block"><div class="japow-bys-size-block__label">Select size</div><div class="japow-bys-size-tiles">' + sizesHtml + '</div></div>' : '') +
          swapHtml +
          '<div class="japow-bys-atc-bar">' +
            '<div class="japow-bys-atc-bar__total"><span class="japow-bys-atc-bar__label">Top + bottom</span><span class="japow-bys-atc-bar__price-wrap">' +
              '<strong>' + money(total) + '</strong>' +
            '</span></div>' +
            '<button type="button" class="japow-bys-btn" data-action="bl-atc"' + (!canAdd ? ' disabled' : '') + '><span>Add Both to Cart</span>' + CART_ICON + '</button>' +
          '</div>'
        ) : '<div class="japow-bys-empty-note">This combination isn\'t set up yet — add both a Top and Bottom product for this weight in the theme editor.</div>') +
        '<button type="button" class="japow-bys-restart" data-action="restart-bl">Start over</button>';
    }

    function stageBLSuccess(){
      return '<div class="japow-bys-success">' + CHECK_ICON_WRAP + '<div class="japow-bys-success__text"><strong>Added to your cart</strong><span>Base layer top &amp; bottom' + (state.blSize ? (' &middot; Size ' + escapeHtml(state.blSize)) : '') + '</span></div></div>';
    }

    function stageError(){
      return '<div class="japow-bys-success japow-bys-success__error">' +
        '<div class="japow-bys-success__icon japow-bys-success__icon--error">!</div>' +
        '<div class="japow-bys-success__text"><strong>Couldn\'t add to cart</strong><span>' + escapeHtml(lastError) + '</span></div></div>' +
        '<button type="button" class="japow-bys-restart" data-action="dismiss-error">Try again</button>';
    }

    function stageKitCategory(){
      var sockCount = kitSlots('sock').length;
      var headwearCount = kitSlots('headwear').length;
      return '<div class="japow-bys-stage-heading">Complete Your Kit</div>' +
        '<div class="japow-bys-stage-label">Step 1 &mdash; Pick a category</div>' +
        '<div class="japow-bys-tile-row japow-bys-tile-row--2">' +
          '<button type="button" class="japow-bys-tile" data-action="kit-category" data-value="sock"' + (!sockCount ? ' disabled' : '') + '><span class="japow-bys-tile__label">Snow Socks</span><span class="japow-bys-tile__sub">' + (sockCount ? (state.kitDone.sock ? 'Already in your cart &mdash; add another' : sockCount + ' option' + (sockCount === 1 ? '' : 's') + ' to choose from') : 'Coming soon') + '</span></button>' +
          '<button type="button" class="japow-bys-tile" data-action="kit-category" data-value="headwear"' + (!headwearCount ? ' disabled' : '') + '><span class="japow-bys-tile__label">Headwear</span><span class="japow-bys-tile__sub">' + (headwearCount ? (state.kitDone.headwear ? 'Already in your cart &mdash; add another' : headwearCount + ' option' + (headwearCount === 1 ? '' : 's') + ' to choose from') : 'Coming soon') + '</span></button>' +
        '</div>';
    }

    function stageKitOptions(){
      var kind = state.currentKitCategory;
      var icon = kind === 'sock' ? ICON_FALLBACK.sock : ICON_FALLBACK.headwear;
      var label = kind === 'sock' ? 'Snow Socks' : 'Headwear';
      var slots = kitSlots(kind);
      var tiles = slots.map(function(s){ return kitOptionTileHtml(kind, s.index, s.data, icon); }).join('');
      return '<div class="japow-bys-stage-heading">Complete Your Kit</div>' +
        '<div class="japow-bys-stage-label">Step 2 &mdash; Choose your ' + label + '</div>' +
        '<div class="japow-bys-tile-row japow-bys-tile-row--4">' + tiles + '</div>' +
        '<button type="button" class="japow-bys-restart" data-action="restart-kit">Start over</button>';
    }

    function stageKitSize(){
      var kind = state.currentKitCategory;
      var icon = kind === 'sock' ? ICON_FALLBACK.sock : ICON_FALLBACK.headwear;
      var label = kind === 'sock' ? 'Snow Socks' : 'Headwear';
      var kicker = kind === 'sock' ? 'Snow Sock' : 'Headwear';
      var slot = getKitSlot(kind, state.kitOptionIndex);
      var variantLabel = kind === 'sock' ? 'Size' : 'Colour';
      var hasOptions = !!(slot && slot.optionValues && slot.optionValues.length > 0);
      var variantHtml = hasOptions ? optionTiles('kit-variant-pick', slot, state.kitVariant) : '';
      return '<div class="japow-bys-stage-heading">Complete Your Kit</div>' +
        '<div class="japow-bys-stage-label">Step 3 &mdash; Select ' + variantLabel.toLowerCase() + '</div>' +
        '<div class="japow-bys-result japow-bys-result--single">' + recapCardHtml(kicker, slot, icon) + '</div>' +
        (hasOptions ? '<div class="japow-bys-size-block"><div class="japow-bys-size-block__label">Select ' + variantLabel.toLowerCase() + '</div><div class="japow-bys-size-tiles">' + variantHtml + '</div></div>' : '') +
        '<div class="japow-bys-atc-bar">' +
          '<div class="japow-bys-atc-bar__total"><span class="japow-bys-atc-bar__label">' + label + '</span><span class="japow-bys-atc-bar__price-wrap"><strong>' + money(slot ? slot.price : 0) + '</strong></span></div>' +
          '<button type="button" class="japow-bys-btn" data-action="kit-atc"' + ((hasOptions && !state.kitVariant) ? ' disabled' : '') + '><span>Add to Cart</span>' + CART_ICON + '</button>' +
        '</div>' +
        '<button type="button" class="japow-bys-restart" data-action="restart-kit">Start over</button>';
    }

    function stageKitSuccess(){
      var kind = state.currentKitCategory;
      var other = kind === 'sock' ? 'headwear' : 'sock';
      var otherLabel = other === 'sock' ? 'Snow Socks' : 'Headwear';
      var thisLabel = kind === 'sock' ? 'Snow Socks' : 'Headwear';
      var thisVariantLabel = kind === 'sock' ? 'Size' : 'Colour';
      var otherAvailable = kitSlots(other).length > 0;
      var otherDone = state.kitDone[other];
      var variantText = state.kitVariant ? (' &middot; ' + thisVariantLabel + ' ' + escapeHtml(state.kitVariant)) : '';
      var html = '<div class="japow-bys-success">' + CHECK_ICON_WRAP + '<div class="japow-bys-success__text"><strong>Added to your cart</strong><span>' + thisLabel + variantText + '</span></div></div>';
      if (otherDone || !otherAvailable){
        html += '<div class="japow-bys-complete-note">Your kit is complete.<button type="button" class="japow-bys-restart" data-action="build-another">Build another kit</button></div>';
      } else {
        html += '<div class="japow-bys-offer"><p>Want ' + otherLabel + ' too?</p>' +
          '<div class="japow-bys-offer__actions">' +
            '<button type="button" class="japow-bys-btn japow-bys-btn--sm" data-action="kit-add-other" data-value="' + other + '"><span>Add ' + otherLabel + '</span></button>' +
            '<button type="button" class="japow-bys-restart" data-action="kit-finish">No thanks, I&rsquo;m done</button>' +
          '</div></div>';
      }
      return html;
    }

    function stageAllDone(){
      return '<div class="japow-bys-success"><div class="japow-bys-success__icon">' + CHECK_SVG + '</div><div class="japow-bys-success__text"><strong>Kit complete</strong><span>Your gear is on its way. Enjoy the snow.</span></div></div>' +
        '<button type="button" class="japow-bys-restart" data-action="build-another">Build another kit</button>';
    }

    var STAGE_RENDERERS = {
      gender: stageGender, weight: stageWeight, blsize: stageBLSize, blsuccess: stageBLSuccess,
      kitcategory: stageKitCategory, kitoptions: stageKitOptions, kitsize: stageKitSize, kitsuccess: stageKitSuccess,
      alldone: stageAllDone, error: stageError
    };
    var stageBeforeError = 'gender';

    function renderCurrent(){
      stageEl.innerHTML = STAGE_RENDERERS[currentStage]();
    }

    function advanceTo(name, summaryHtml){
      currentStage = name;
      stageEl.classList.add('is-leaving');
      setTimeout(function(){
        if (summaryHtml){
          historyEl.innerHTML = '<div class="japow-bys-history__bar">' + summaryHtml + '</div>';
          historyEl.classList.add('is-visible');
        } else {
          historyEl.classList.remove('is-visible');
          historyEl.innerHTML = '';
        }
        renderCurrent();
        stageEl.classList.remove('is-leaving');
        stageEl.classList.add('is-entering');
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){ stageEl.classList.remove('is-entering'); });
        });
        // Adding to cart can collapse a much taller stage (e.g. the OOS swap
        // picker) down to a short success message — without this, the page
        // keeps its old scroll position and the user ends up looking at
        // whatever section now sits there instead of this one. Snap back to
        // the top of the section whenever that collapse happens.
        if (name === 'blsuccess' || name === 'kitsuccess'){
          var sectionEl = root.closest('.japow-section') || root;
          sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 380);
    }

    function showError(message, returnTo){
      lastError = message;
      stageBeforeError = returnTo;
      advanceTo('error', null);
    }

    function addToCart(items, onSuccess, onFail){
      if (cartBusy) return;
      cartBusy = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(res){
        if (!res.ok){
          return res.json().then(function(body){ throw new Error((body && body.description) || 'This item could not be added to your cart.'); });
        }
        return res.json();
      }).then(function(){
        cartBusy = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        onSuccess();
      }).catch(function(err){
        cartBusy = false;
        onFail(err && err.message ? err.message : 'This item could not be added to your cart.');
      });
    }

    root.addEventListener('click', function(e){
      var actionEl = e.target.closest('[data-action]');
      if (!actionEl || actionEl.disabled) return;
      var action = actionEl.getAttribute('data-action');
      var value = actionEl.getAttribute('data-value');

      if (action === 'bl-gender'){
        state.gender = value;
        state.topOverride = null; state.bottomOverride = null;
        state.topColorOverride = null; state.bottomColorOverride = null;
        advanceTo('weight', GENDER_LABEL[state.gender]);
      } else if (action === 'bl-weight'){
        state.weight = value;
        state.blSize = null;
        state.topOverride = null; state.bottomOverride = null;
        state.topColorOverride = null; state.bottomColorOverride = null;
        advanceTo('blsize', GENDER_LABEL[state.gender] + ' &middot; ' + WEIGHT_LABEL[state.weight]);
      } else if (action === 'bl-size-pick'){
        state.blSize = value;
        state.topColorOverride = null; state.bottomColorOverride = null;
        renderCurrent();
      } else if (action === 'bl-swap-part'){
        var swapPart = actionEl.getAttribute('data-part');
        if (swapPart === 'top'){ state.topOverride = value; state.topColorOverride = null; }
        else if (swapPart === 'bottom'){ state.bottomOverride = value; state.bottomColorOverride = null; }
        renderCurrent();
      } else if (action === 'bl-swap-color'){
        var colorPart = actionEl.getAttribute('data-part');
        if (colorPart === 'top') state.topColorOverride = value;
        else if (colorPart === 'bottom') state.bottomColorOverride = value;
        renderCurrent();
      } else if (action === 'bl-swap-reset'){
        var resetPart = actionEl.getAttribute('data-part');
        if (resetPart === 'top'){ state.topOverride = null; state.topColorOverride = null; }
        else if (resetPart === 'bottom'){ state.bottomOverride = null; state.bottomColorOverride = null; }
        renderCurrent();
      } else if (action === 'bl-atc'){
        var ctb2 = currentTopBottom();
        var top = ctb2.top, bottom = ctb2.bottom;
        if (!top || !bottom) return;
        var hasOptions = (top.optionValues && top.optionValues.length > 0) || (bottom.optionValues && bottom.optionValues.length > 0);
        if (hasOptions && !state.blSize) return;
        var topVariant = hasOptions ? effectiveVariant(top, state.blSize, state.topColorOverride) : firstVariant(top);
        var bottomVariant = hasOptions ? effectiveVariant(bottom, state.blSize, state.bottomColorOverride) : firstVariant(bottom);
        if (!topVariant || !bottomVariant || !topVariant.available || !bottomVariant.available){
          showError('That size just went out of stock for one of these pieces — try a different size or swap in an alternative.', 'blsize');
          return;
        }
        addToCart(
          [{ id: topVariant.id, quantity: 1 }, { id: bottomVariant.id, quantity: 1 }],
          function(){
            var summary = GENDER_LABEL[state.gender] + ' &middot; ' + WEIGHT_LABEL[state.weight] + (state.blSize ? (' &middot; Size ' + escapeHtml(state.blSize)) : '');
            advanceTo('blsuccess', summary);
            setTimeout(function(){ advanceTo('kitcategory', null); }, 1500);
          },
          function(msg){ showError(msg, 'blsize'); }
        );
      } else if (action === 'kit-category'){
        state.currentKitCategory = value;
        advanceTo('kitoptions', null);
      } else if (action === 'kit-option'){
        state.kitOptionIndex = parseInt(value, 10);
        state.kitVariant = null;
        var kSlot = getKitSlot(state.currentKitCategory, state.kitOptionIndex);
        var kLabel = state.currentKitCategory === 'sock' ? 'Snow Socks' : 'Headwear';
        advanceTo('kitsize', kLabel + ': ' + escapeHtml(kSlot.title));
      } else if (action === 'kit-variant-pick'){
        state.kitVariant = value;
        renderCurrent();
      } else if (action === 'kit-atc'){
        var slot2 = getKitSlot(state.currentKitCategory, state.kitOptionIndex);
        if (!slot2) return;
        var hasOptions2 = slot2.optionValues && slot2.optionValues.length > 0;
        if (hasOptions2 && !state.kitVariant) return;
        var variantEntry = hasOptions2 ? slot2.variantMap[state.kitVariant] : firstVariant(slot2);
        if (!variantEntry || !variantEntry.available){
          showError('That option just went out of stock — try a different one.', 'kitsize');
          return;
        }
        addToCart(
          [{ id: variantEntry.id, quantity: 1 }],
          function(){
            state.kitDone[state.currentKitCategory] = true;
            var lbl = state.currentKitCategory === 'sock' ? 'Snow Socks' : 'Headwear';
            var vlbl = state.currentKitCategory === 'sock' ? 'Size' : 'Colour';
            var summary = lbl + ': ' + escapeHtml(slot2.title) + (state.kitVariant ? (' &middot; ' + vlbl + ' ' + escapeHtml(state.kitVariant)) : '');
            advanceTo('kitsuccess', summary);
          },
          function(msg){ showError(msg, 'kitsize'); }
        );
      } else if (action === 'kit-add-other'){
        state.currentKitCategory = value;
        state.kitOptionIndex = null;
        state.kitVariant = null;
        advanceTo('kitoptions', null);
      } else if (action === 'kit-finish'){
        advanceTo('alldone', null);
      } else if (action === 'dismiss-error'){
        advanceTo(stageBeforeError, null);
      } else if (action === 'restart-bl'){
        state.gender = null; state.weight = null; state.blSize = null;
        state.topOverride = null; state.bottomOverride = null;
        state.topColorOverride = null; state.bottomColorOverride = null;
        advanceTo('gender', null);
      } else if (action === 'restart-kit'){
        state.gender = null; state.weight = null; state.blSize = null;
        state.topOverride = null; state.bottomOverride = null;
        state.topColorOverride = null; state.bottomColorOverride = null;
        state.currentKitCategory = null; state.kitOptionIndex = null; state.kitVariant = null;
        state.kitDone = { sock: false, headwear: false };
        advanceTo('gender', null);
      } else if (action === 'build-another'){
        state.gender = null; state.weight = null; state.blSize = null;
        state.topOverride = null; state.bottomOverride = null;
        state.topColorOverride = null; state.bottomColorOverride = null;
        state.currentKitCategory = null; state.kitOptionIndex = null; state.kitVariant = null;
        state.kitDone = { sock: false, headwear: false };
        advanceTo('gender', null);
      }
    });

    function firstVariant(slot){
      var keys = Object.keys(slot.variantMap).filter(function(k){ return k !== '_'; });
      return keys.length ? slot.variantMap[keys[0]] : null;
    }

    renderCurrent();
  }

  function initAll(context){
    (context || document).querySelectorAll('.japow-bys-wizard').forEach(initWizard);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector ? e.target.querySelector('.japow-bys-wizard') : null;
    if (root){
      var sid = root.getAttribute('data-section-id');
      if (sid) delete initialized[sid];
      initWizard(root);
    }
  });
})();
